import { ApiTypes } from '../../api/api-types';
import { QUESTION_TYPES } from '../../core/interfaces/general.interface';
import { OneMoreQuestion } from './interfaces/one-more-question.interface';

type OmqDto = ApiTypes.OneMoreQuestionTakeawayResponseDto;

function toDisplayColumns(value: number | null | undefined): 2 | 3 | 4 | undefined {
  return value === 2 || value === 3 || value === 4 ? value : undefined;
}

/**
 * Adapts the drawn one-more-question DTO into the frontend `OneMoreQuestion` view model,
 * mapping `type` -> QuestionType and `displayColumns` -> 2|3|4 and recursing into follow-ups.
 * The client-only `statement` is filled in later by the component.
 */
export function toOneMoreQuestion(dto: OmqDto): OneMoreQuestion {
  return {
    ...dto,
    type: QUESTION_TYPES[dto.type],
    displayColumns: toDisplayColumns(dto.displayColumns),
    followUpQuestions: dto.followUpQuestions.map(toOneMoreQuestion),
  };
}
